import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getData } from "../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../interfaces/response";

export interface IUserUnlockApprovalHistoryEntry {
  email: string;
  approvalComment: string;
  initiatedByUserName: string;
  dateInitiated: string;
  approvedByUserName: string;
  transactionReference: string;
  workflowCode: string;
  statusText: string;
  lockReason: string;
  additionalLockDescription: string;
  additionalUnlockDescription: string;
  unlockReason: string;
}

const getUserUnlockApprovalHistory = async (
  targetId: string,
): Promise<IResponse<IUserUnlockApprovalHistoryEntry[]>> => {
  const response = await getData(
    `${ajaxEndpoints.USER_UNLOCK_APPROVAL_HISTORY}/${targetId}`,
  );
  return response.data;
};

export default function useGetUserUnlockApprovalHistory(
  targetId: string | null,
) {
  return useQuery<IResponse<IUserUnlockApprovalHistoryEntry[]>, Error>(
    [targetId, "getUserUnlockApprovalHistory"],
    () => getUserUnlockApprovalHistory(targetId!),
    {
      enabled: !!targetId,
      refetchOnWindowFocus: false,
    },
  );
}
